import { useCurrentCreatorbaseUser } from 'Modules/Auth/hooks/useCurrentCreatorbaseUser';
import { useCurrentUserClients as useSharedUserClients } from '@round/creatorbase-helpers';

// Sources the creatorbase user id from this app's auth context and delegates fetching/aggregation to
// the shared hook.
export default function useCurrentUserClients() {
    const { creatorbaseUserId } = useCurrentCreatorbaseUser();
    return useSharedUserClients(creatorbaseUserId);
}
